var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPatientMyReports(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.994,
    height: 70.606,
    viewBox: "0 0 52.994 70.606",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 18",
    d: "M170.751-511.616a2.608 2.608 0 0 0-1.151 1.055l-.411.658-.041 2.481a16.227 16.227 0 0 0 .11 3 3.373 3.373 0 0 0 1.563 1.782l.562.3h9.663c9.635 0 9.663 0 10.211-.3a3.916 3.916 0 0 0 .918-.685c.7-.74.795-1.179.795-3.851 0-2.344-.014-2.467-.343-3.139a3.23 3.23 0 0 0-1.754-1.535c-.26-.1-3.55-.151-9.9-.151h-9.5zm19.805 1.96.356.274v2.179c0 1.919-.027 2.193-.26 2.481l-.26.329H171.7l-.26-.329c-.233-.288-.26-.562-.26-2.481v-2.179l.356-.274c.356-.288.466-.288 9.512-.288s9.152 0 9.508.288z",
    transform: "translate(-154.547 512.25)",
    style: {
      stroke: "#f1772d",
      fill: "#f1772d",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 19",
    d: "M67.447-483.853a4.418 4.418 0 0 0-2.618 2.371l-.329.617v59.758l.329.713a5.2 5.2 0 0 0 2.412 2.316c.672.247 1.3.26 23.506.26s22.834-.014 23.506-.26a5.2 5.2 0 0 0 2.412-2.316l.329-.713v-59.758l-.384-.726a4.976 4.976 0 0 0-2.124-2.1c-.617-.315-.768-.329-4.509-.37l-3.877-.039-.343.343a.914.914 0 0 0-.082 1.329c.26.329.274.329 4.016.4a21.894 21.894 0 0 1 4.016.233 3.208 3.208 0 0 1 1.151 1.316c.11.274.151 9.293.151 29.605 0 27.549-.014 29.249-.247 29.687a3.186 3.186 0 0 1-.754.891l-.535.425-22.355.041c-12.308.014-22.574 0-22.821-.041a2.736 2.736 0 0 1-1.617-1.4c-.164-.37-.192-5.428-.192-29.632 0-20.285.041-29.3.151-29.578a3.208 3.208 0 0 1 1.151-1.316 21.894 21.894 0 0 1 4.016-.233c3.742-.069 3.755-.069 4.016-.4a.9.9 0 0 0-.082-1.316l-.329-.343h-3.674c-2.974.016-3.797.058-4.29.236z",
    transform: "translate(-64.25 488.174)",
    style: {
      stroke: "#f1772d",
      fill: "#f1772d",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 20",
    d: "M111.335-404.761a2.669 2.669 0 0 0-1.933 1.521c-.206.4-.26.891-.3 2.961-.069 3.015.069 3.824.754 4.578.809.9 1.22.987 4.578.932 2.81-.041 2.96-.055 3.454-.37a3.605 3.605 0 0 0 .891-.877c.37-.548.37-.562.411-3.5.041-2.467.014-3.043-.178-3.536a2.845 2.845 0 0 0-1.974-1.686 34.487 34.487 0 0 0-5.703-.023z",
    transform: "translate(-102.724 419.8)",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "#f1772d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21",
    d: "M225.807-394.591a1.048 1.048 0 0 0-.452 1.686c.274.274.452.274 11.9.274 11.253 0 11.636-.014 11.869-.26a1.085 1.085 0 0 0-.041-1.425l-.3-.3-11.335-.014c-6.241-.016-11.476-.002-11.641.039z",
    transform: "translate(-202.833 410.973)",
    style: {
      stroke: "#f1772d",
      fill: "#f1772d",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 22",
    d: "M225.3-355.685a.965.965 0 0 0 .055 1.453c.356.288.507.288 6.25.288h5.88l.329-.343a.878.878 0 0 0 0-1.371l-.329-.343h-11.9z",
    transform: "translate(-202.747 377.631)",
    style: {
      stroke: "#f1772d",
      fill: "#f1772d",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 23",
    d: "M110.919-278.794a3.085 3.085 0 0 0-1.055.754c-.713.795-.836 1.535-.768 4.578.055 2.769.192 3.276 1.1 3.961.713.535 1.371.644 4.016.644 2.755 0 3.289-.1 4-.726.9-.795 1-1.179 1-4.29 0-3.55-.178-4.1-1.562-4.783-.658-.329-.768-.343-3.427-.343a14.311 14.311 0 0 0-3.304.205z",
    transform: "translate(-102.719 311.185)",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "#f1772d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 24",
    d: "M225.287-268.712a.992.992 0 0 0-.055 1.494c.3.274.411.274 11.856.274 11.376 0 11.554 0 11.828-.274a.953.953 0 0 0-.082-1.48l-.343-.3h-11.417c-11.348-.002-11.417-.002-11.787.286z",
    transform: "translate(-202.683 302.556)",
    style: {
      stroke: "#f1772d",
      fill: "#f1772d",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25",
    d: "M225.3-229.726a1.089 1.089 0 0 0 .014 1.453c.274.247.576.26 6.318.26h6.031l.26-.329a.966.966 0 0 0-.055-1.357c-.315-.3-.343-.3-6.3-.3-5.821-.001-6.012.013-6.268.273z",
    transform: "translate(-202.773 268.901)",
    style: {
      stroke: "#f1772d",
      fill: "#f1772d",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 26",
    d: "M110.648-152.726a3.826 3.826 0 0 0-.918.74c-.617.7-.754 1.59-.7 4.537.055 2.495.055 2.495.466 3.152a2.787 2.787 0 0 0 1.014.987c.576.3.726.315 3.6.315 3.331 0 3.66-.069 4.4-.959.589-.7.672-1.206.617-4.345l-.041-2.892-.411-.6a3.4 3.4 0 0 0-1.028-.9c-.576-.288-.768-.3-3.564-.3-2.626.005-2.996.032-3.435.265z",
    transform: "translate(-102.668 202.455)",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "#f1772d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 27",
    d: "M225.232-142.726a.992.992 0 0 0 .055 1.494c.37.288.439.288 11.787.288h11.417l.343-.315a.938.938 0 0 0 .082-1.467c-.274-.274-.452-.274-11.828-.274-11.444 0-11.554 0-11.856.274z",
    transform: "translate(-202.683 193.825)",
    style: {
      stroke: "#f1772d",
      fill: "#f1772d",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 28",
    d: "M225.606-104.668a1.033 1.033 0 0 0-.411 1.686c.26.26.452.274 6.277.274h6.017l.288-.315a.978.978 0 0 0 .041-1.343l-.26-.329-5.88-.027c-3.221-.014-5.962.013-6.072.054z",
    transform: "translate(-202.673 160.797)",
    style: {
      stroke: "#f1772d",
      fill: "#f1772d",
      strokeWidth: ".5px"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientMyReports);
export default __webpack_public_path__ + "static/media/patientMyReports.8a365035a3767962eee8f218d12f1ddb.svg";
export { ForwardRef as ReactComponent };